import { useState, useEffect } from 'react';
import { collection, onSnapshot, query, orderBy, where } from 'firebase/firestore';
import { db } from '../lib/firebaseClient';

const COLLECTION_NAME = 'shopping_list_items';

/**
 * Real-time subscription hook for shopping list items
 * Returns live data that updates automatically when Firestore changes
 * 
 * @param {Object} options - Options for filtering
 * @param {boolean} options.showPurchased - Include purchased items (default: false)
 */
export const useShoppingListItems = (options = {}) => {
  const { showPurchased = false } = options;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    // Create query based on options
    let q;
    if (showPurchased) {
      // Show all items
      q = query(
        collection(db, COLLECTION_NAME),
        orderBy('addedAt', 'desc')
      );
    } else {
      // Only show unpurchased items
      q = query(
        collection(db, COLLECTION_NAME),
        where('isPurchased', '==', false),
        orderBy('addedAt', 'desc')
      );
    }

    // Subscribe to real-time updates
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const shoppingItems = [];
        snapshot.forEach((doc) => {
          shoppingItems.push({
            id: doc.id,
            ...doc.data(),
            // Convert Firestore timestamps to Date objects for easier handling
            addedAt: doc.data().addedAt?.toDate?.() || doc.data().addedAt,
            purchasedAt: doc.data().purchasedAt?.toDate?.() || doc.data().purchasedAt,
            updatedAt: doc.data().updatedAt?.toDate?.() || doc.data().updatedAt,
          });
        });
        setItems(shoppingItems);
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching shopping list items:', err);
        setError(err);
        setLoading(false);
      }
    );

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [showPurchased]);

  return { items, loading, error };
};







